$(document).ready(function() {
  const swiperScene = new Swiper('.swiper-scene', {
    // slidesPerView: 'auto',
    slidesPerView:4.5,
    spaceBetween: 20,
    breakpoints: {
      300: {
        slidesPerView: 2.8,
        spaceBetween: 10,
      },
      768: {
        slidesPerView:4.5,
        spaceBetween: 20,
      }
    },
    loopAddBlankSlides: true,
    loop:true,
    // loopAdditionalSlides: 10,
    speed:4000,
    autoplay: {
     delay: 0,
      stopOnLastSlide: false
   },
  })
  const swiperCollection = new Swiper('.swiper-collection', {
    // slidesPerView: 'auto',
    slidesPerView:4,
    spaceBetween: 10,
    breakpoints: {
      300: {
        slidesPerView: 2.8,
        spaceBetween: 8,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 10,
      }
    },
    scrollbar: {
        el: ".swiper-collection .swiper-scrollbar",
      hide:false
    }
  })

  $('.watch-btn').click(function() {
    $('.sec-2-row-bottom .grid-item').removeClass('mobile-hide')
  })
})